<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-col>
          <h1 class="display-2 font-weight-bold mb-3">Telefonlar Ekleme</h1>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="3">
                <v-select
                  v-model="phone.brand"
                  :items="brands"
                  item-text="title"
                  item-value="id"
                  label="Marka"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="phone.model"
                  :items="models"
                  item-text="title"
                  item-value="id"
                  label="Model"
                  :rules="[rules.required]"
                  :disabled="!phone.brand"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="phone.color"
                  :items="colors"
                  label="Renk"
                  item-text="title"
                  item-value="id"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-date-input 
                label="Garanti Bitiş Tarihi" 
                v-model="warrantyDate" 
                @change="onDateSelected">
            </v-date-input>

              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="phone.storage"
                  :items="storageOptions"
                  item-text="title"
                  item-value="id"
                  label="Hafıza"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="phone.deviceCondition"
                  :items="deviceConditions"
                  label="Cihaz Durumu"
                  item-text="title"
                  item-value="id"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="phone.cosmeticCondition"
                  :items="cosmeticConditions"
                  label="Kozmetik Durumu"
                  item-text="title"
                  item-value="id"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="phone.backCameraCondition"
                  :items="[
                    { title: 'Evet', id: true },
                    { title: 'Hayır', id: false },
                  ]"
                  label="Arka Kamera Çalışıyormu ?"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="phone.frontCameraWorking"
                  :items="[
                    { title: 'Evet', id: true },
                    { title: 'Hayır', id: false },
                  ]"
                  label="Ön Kamera Çalışıyor mu?"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="phone.faceIdWorking"
                  :items="[
                    { title: 'Evet', id: true },
                    { title: 'Hayır', id: false },
                  ]"
                  label="FaceID Çalışıyor mu?"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="phone.batteryCondition"
                  :items="batteryConditions"
                  label="Batarya Durumu"
                  item-text="title"
                  item-value="id"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
             
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="phone.imei"
                  label="IMEI No"
                  :rules="[rules.required, rules.imei]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="phone.change_item"
                  label="Değişen Parçalar"
                  :rules="[rules.required, rules.change_item]"
                  required
                ></v-text-field>
              </v-col>

            </v-row>
            <v-row>
            <v-col cols="4">
                <v-text-field
                  v-model="phone.purchase"
                  label="Alış Fiyatı"
                  :rules="[rules.required, rules.imei]"
                  required
                ></v-text-field>
              </v-col>
        
            <v-col cols="4">
                <v-text-field
                  v-model="phone.supportedPurchase"
                  label="Destekli Alış Fiyatı"
                  :rules="[rules.required, rules.imei]"
                  required
                ></v-text-field>
              </v-col>
    
            <v-col cols="4">
                <v-text-field
                  v-model="phone.sale"
                  label="Satış Fiyatı"
                  :rules="[rules.required, rules.imei]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-btn
              color="primary"
              class="mr-4"
              @click="addPhone"
              :disabled="!valid"
            >
              Kaydet
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import { mapState } from "vuex";

import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar
import { VDateInput } from 'vuetify/labs/VDateInput'

export default {
  name: "PhoneList",
  components: {
    MainLayout,
    VDateInput
  },
 
  data() {
    return {
      brands: [],
      models: [], // Seçilen markaya göre modeller
      warrantyMenu: false,
      phone: {
        brand: '',
        model: '',
        warrantyDate: new Date().toISOString().substr(0, 10),
        color : '',
        storage : '',
        deviceCondition : '',
        cosmeticCondition : '',
        backCameraCondition : '',
        frontCameraWorking : '',
        faceIdWorking : '',
        batteryCondition : '',
        imei : '',
        change_item : '',
        purchase : '',
        supportedPurchase : '',
        sale : ''
       },

      headers: [
        { text: "Adı", value: "fullname" },
        { text: "Marka", value: "phone" },
        { text: "Model", value: "email" },
        { text: "Renk", value: "email" },
        { text: "Özellikler", value: "type" },
        { text: "İşlemler", value: "actions", sortable: false }, // Aksiyonlar için
      ],
      storageOptions: [
        { title: "1GB", id: "1" },
        { title: "2GB", id: "2" },
        { title: "4GB", id: "4" },
        { title: "8GB", id: "8" },
        { title: "16GB", id: "16" },
        { title: "32GB", id: "32" },
        { title: "64GB", id: "64" },
        { title: "128GB", id: "128" },
        { title: "256GB", id: "256" },
        { title: "512GB", id: "512" },
        { title: "1TB", id: "1024" },
      ],
      deviceConditions: [
        { title: "Yeni", id: "1" },
        { title: "Yeni Gibi", id: "2" },
        { title: "Kötü", id: "3" },
      ],
      cosmeticConditions: [
        { title: "Yeni", id: "1" },
        { title: "Yeni Gibi", id: "2" },
        { title: "Kötü", id: "3" },
        { title: "Çizikler Var", id: "3" },
      ],
      batteryConditions: [
        { title: "İyi", id: "1" },
        { title: "Normal", id: "2" },
        { title: "Zayıf", id: "3" },
      ],

      select: { name: "Seçiniz", id: "0" },
      loading: false, // Yükleniyor durumu
      search: "", // Arama metni
      addPhoneDialog: false, // Kullanıcı ekleme modal durumu
    
      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
      typeItems: [
        { text: "Telefon", value: "normal" },
        { text: "Cari", value: "supplier" },
      ],
    };
  },

  computed: {
    ...mapState(["Phone"]), // Vuex state'inden Phone'ı al
    minDate() {
        return new Date().toISOString().slice(0, 10)
    }
  },
  created() {
    // Component oluşturulduğunda markaları yükle
    this.getBrands();
    this.getColor();
  },
  watch: {
    // Marka değiştiğinde modelleri güncelle
    "phone.brand": {
      handler: "onBrandChange",
      immediate: true,
    },
  },
  methods: {
    onDateSelected(date) {
      console.log("Seçilen Tarih:", date);
      // Tarih seçildiğinde yapılacak işlemler
      this.confirmDate();
    },
    confirmDate() {
      // "OK" butonuna basılmış gibi davran
      console.log("Tarih onaylandı:", this.selectedDate);
    },
    showAddPhoneDialog() {
      this.resetNewPhone(); // Formu sıfırla
      this.addPhoneDialog = true; // Modalı göster
    },

    async addPhone() {
      if (this.$refs.form.validate()) {
        // Formu doğrula
        try {
          await mainService.add(this.phone,'phones'); // Yeni kullanıcıyı ekle
          this.addPhoneDialog = false; // Modalı kapat
          this.resetNewPhone(); // Yeni kullanıcı formunu sıfırla
          Swal.fire("Silindi!", "Telefon başarıyla Eklendi.", "success");
        } catch (error) {
          console.error("Kullanıcı eklenirken hata oluştu:", error);
        }
      }
    },

    async editPhone(PhoneId) {
      // Kullanıcı bilgilerini al
      const PhoneToEdit = this.phoneList.find((Phone) => Phone.id === PhoneId);
      if (PhoneToEdit) {
        this.newPhone = {
          ...PhoneToEdit,
        }; // Kullanıcı bilgilerini form alanlarına doldur
        this.addPhoneDialog = true; // Modalı aç
      }
    },

    async getBrands() {
      try {
        this.loading = true;
        const response = await mainService.list("brands");
        // API'den gelen veriyi select componenti için uygun formata dönüştür
        this.brands = response.map((brand) => ({
          title: brand.name, // Görüntülenecek marka adı
          id: brand.id, // Seçildiğinde kaydedilecek marka ID'si
          models: brand.models, // Modelleri de saklayalım (sonraki select için)
        }));
        console.log(this.brands);
      } catch (error) {
        console.error("Markalar yüklenirken hata oluştu:", error);
        Swal.fire({
          icon: "error",
          title: "Hata!",
          text: "Markalar yüklenirken bir hata oluştu.",
        });
      } finally {
        this.loading = false;
      }
    },

    async getColor() {
      try {
        this.loading = true;
        const response = await mainService.list("colors");
        // API'den gelen veriyi select componenti için uygun formata dönüştür
        this.colors = response.map((color) => ({
          title: color.title, // Görüntülenecek marka adı
          id: color.id, // Seçildiğinde kaydedilecek marka ID'si
        }));
      } catch (error) {
        console.error("Markalar yüklenirken hata oluştu:", error);
        Swal.fire({
          icon: "error",
          title: "Hata!",
          text: "Renkler yüklenirken bir hata oluştu.",
        });
      } finally {
        this.loading = false;
      }
    },

    // Marka seçildiğinde modelleri filtrelemek için yeni bir method
    onBrandChange() {
      if (this.phone.brand) {
        const selectedBrand = this.brands.find(
          (b) => b.id === this.phone.brand
        );
        if (selectedBrand && selectedBrand.models) {
          this.models = selectedBrand.models.map((model) => ({
            title: model.name,
            id: model.id,
          }));
        }
      } else {
        this.models = [];
      }
      // Marka değiştiğinde model seçimini sıfırla
      this.phone.model = null;
    },

    resetNewPhone() {
      this.phone = {
        brand : "",
        model : "",
        color : "",
        warrantyDate : "",
        storage : "",
        deviceCondition : "",
        cosmeticCondition : "",
        backCameraCondition : "",
        frontCameraWorking : "",
        faceIdWorking : "",
        batteryCondition : "",
        imei : "",
        change_item : "",
        purchase : "",
        supportedPurchase : "",
        sale : ""
      };  
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
